import { connect } from 'react-redux';

import { SocialLoginButtons } from '@eb/social-login-facebook';

import { socialLogInUserNotAuthorized as socialLogInUserNotAuthorizedAction } from '../actions/social';

const _mapStateToProps = ({ authentication }) => ({
    socialSSOSettings: authentication.socialSSOSettings,
    shouldUseApplePopup:
        authentication.featureFlags.launchAuthenticationRefactor,
});

const _mapDispatchToProps = {
    onSocialConnectNotAuthorized: socialLogInUserNotAuthorizedAction,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(SocialLoginButtons);
